var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "productQuotationApplicationAdd container" },
    [
      _c(
        "div",
        { staticClass: "searchBox" },
        [
          _c(
            "el-row",
            { attrs: { type: "flex" } },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn",
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.go(-1)
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("common.close")))]
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              ref: "applyInfoForm",
              staticClass: "topform",
              attrs: { "label-width": "140px", model: _vm.headData },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "报价确认单据编号" } },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.headData.sourcingNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.headData, "sourcingNo", $$v)
                              },
                              expression: "headData.sourcingNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("nav.productQuotationApplication"),
                          },
                        },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.headData.applyNo,
                              callback: function ($$v) {
                                _vm.$set(_vm.headData, "applyNo", $$v)
                              },
                              expression: "headData.applyNo",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "主题" } },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.headData.subject,
                              callback: function ($$v) {
                                _vm.$set(_vm.headData, "subject", $$v)
                              },
                              expression: "headData.subject",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建人" } },
                        [
                          _c("el-input", {
                            staticClass: "handle-input",
                            staticStyle: { width: "100%" },
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.headData.creater,
                              callback: function ($$v) {
                                _vm.$set(_vm.headData, "creater", $$v)
                              },
                              expression: "headData.creater",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "创建日期" } },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              "value-format": "yyyy-MM-dd",
                              type: "date",
                              disabled: "",
                            },
                            model: {
                              value: _vm.headData.createDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.headData, "createDate", $$v)
                              },
                              expression: "headData.createDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-tabs",
        {
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "产品报价明细", name: "first" } },
            [
              _c(
                "ux-grid",
                {
                  ref: "dataTable",
                  attrs: {
                    data: _vm.tableData,
                    "keep-source": "",
                    "max-height": "550",
                    "show-overflow": "tooltip",
                    "highlight-current-row": "",
                  },
                },
                [
                  _vm._l(_vm.columns, function (item, index) {
                    return _c("ux-table-column", {
                      key: index,
                      attrs: {
                        align: "center",
                        resizable: "",
                        field: item.prop,
                        title: item.label,
                        sortable: "",
                        "min-width": item.width,
                      },
                    })
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      field: "effectiveBeginDate",
                      title: "有效开始日期",
                      "min-width": "130",
                      resizable: "",
                      align: "center",
                      sortable: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("dateFormatFilter")(
                                    scope.row.effectiveBeginDate,
                                    "YYYY-MM-DD"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("ux-table-column", {
                    attrs: {
                      field: "isSpecialFreight",
                      title: "非标准线路运费",
                      "min-width": "150",
                      resizable: "",
                      align: "center",
                      sortable: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.isSpecialFreight == "Y"
                                    ? "是"
                                    : "否"
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._l(_vm.columns1, function (item, index) {
                    return _c("ux-table-column", {
                      key: index,
                      attrs: {
                        align: "center",
                        resizable: "",
                        field: item.prop,
                        title: item.label,
                        sortable: "",
                        "min-width": item.width,
                      },
                    })
                  }),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: _vm.$t("common.approvalLog"), name: "log" } },
            [
              _c(
                "el-table",
                {
                  staticClass: "table",
                  attrs: {
                    data: _vm.auditLog,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "",
                      prop: "operatorName",
                      align: "center",
                      label: _vm.$t("common.OperatorName"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "",
                      prop: "createDate",
                      align: "center",
                      label: _vm.$t("common.OperationTime"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("dateFormatFilter")(
                                    scope.row.createDate,
                                    "YYYY-MM-DD HH:mm:ss"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "",
                      prop: "action",
                      align: "center",
                      label: _vm.$t("common.PedagogicalOperation"),
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      "show-overflow-tooltip": "",
                      sortable: "",
                      prop: "comments",
                      align: "center",
                      label: _vm.$t("common.remarks"),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }